<template>
    <div class="channel-result-box">
        <div class="channel-result-box__title">
            <h1>CÁC ĐÀI XỔ SỐ HÔM NAY</h1>
        </div>
        <div class="channel-result-box__tabs">
            <Button
                value="Tất cả"
                @click="setRegion(params.REGION.EN.ALL)"
                theme="dark"
                variant="secondary"
                :class="{
                    'bg-tertiary': !getButtonStatus(params.REGION.EN.ALL),
                    classes: getButtonStatus(params.REGION.EN.ALL),
                }"
            />

            <Button
                value="Đài Miền Bắc"
                @click="setRegion(params.REGION.EN.NORTH)"
                theme="dark"
                variant="secondary"
                :class="{
                    'bg-tertiary': !getButtonStatus(params.REGION.EN.NORTH),
                    classes: getButtonStatus(params.REGION.EN.NORTH),
                }"
            />

            <Button
                value="Đài Miền Trung"
                @click="setRegion(params.REGION.EN.CENTRAL)"
                theme="dark"
                variant="secondary"
                :class="{
                    'bg-tertiary': !getButtonStatus(params.REGION.EN.CENTRAL),
                    classes: getButtonStatus(params.REGION.EN.CENTRAL),
                }"
            />

            <Button
                value="Đài Miền Nam"
                @click="setRegion(params.REGION.EN.SOUTH)"
                theme="dark"
                variant="secondary"
                :class="{
                    'bg-tertiary': !getButtonStatus(params.REGION.EN.SOUTH),
                    classes: getButtonStatus(params.REGION.EN.SOUTH),
                }"
            />
        </div>
        <div class="channel-result-box__cards">
            <ChannelCard
                v-for="(resultItem, index) in getResult()"
                :key="index"
                :title="resultItem.name"
                content="Giờ xổ số"
                :channelId="resultItem.id"
                :secondLeft="resultItem.second_left"
                :channelName="convertRegionToEn(resultItem.region)"
            />
        </div>
    </div>
</template>

<script>
import ChannelCard from '@/components/common/ChannelCard/ChannelCard';
import Button from '@/components/common/Button/Button';
import './LotteryResultToday.scss';
import Vue from 'vue';
import * as params from '@/utils/urlParams';

export default Vue.extend({
    name: 'LotteryResultToday',
    components: {
        ChannelCard,
        Button,
    },
    props: {
        result: {
            required: false,
            default: null,
        },
    },
    data() {
        return {
            region: 'all',
            params: params,
        };
    },
    methods: {
        convertRegionToEn(region) {
            return {
                bac: 'north',
                trung: 'central',
                nam: 'south',
            }[region];
        },
        getResult() {
            if (this.result) {
                return this.region == params.REGION.EN.ALL
                    ? this.result[
                          this.result.findIndex(
                              channel =>
                                  channel.name === params.REGION.EN.NORTH,
                          )
                      ].data.concat(
                          this.result[
                              this.result.findIndex(
                                  channel =>
                                      channel.name === params.REGION.EN.CENTRAL,
                              )
                          ].data,
                          this.result[
                              this.result.findIndex(
                                  channel =>
                                      channel.name === params.REGION.EN.SOUTH,
                              )
                          ].data,
                      )
                    : this.result[
                          this.result.findIndex(
                              channel => channel.name === this.region,
                          )
                      ].data;
            }
            return [];
        },
        setRegion(region) {
            this.switchRegion(region);
            this.region = region;
        },
        getButtonStatus(region) {
            return this.region == region;
        },
        switchRegion(region) {
            this.$emit('switch-region', region);
        },
    },
});
</script>
